import {
  Box,
  Text,
  SimpleGrid,
  Skeleton,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import { usePlayerStory } from "./usePlayerHistory";
import { PlayerEdit } from "../../Components/PlayerEdit";
import Layout from "../../Components/Layout";
import {
  ObjectiveData,
  RegisterObjectiveModal,
} from "../../Components/RegisterObjectiveModal";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { RootState } from "../../Store/types";
import { useSelector } from "react-redux";
import { updateGoal } from "../../Services/objective";
import { routes } from "../../Routes/routers";

export const PlayerHistory: React.FC = () => {
  const toast = useToast();
  const [objectiveData, setObjectiveData] = useState<ObjectiveData>();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const navigate = useNavigate();

  const { history, loading, setLoading, handleLoadPlayerHistory } =
    usePlayerStory();

  const { user } = useSelector((state: RootState) => state);
  const { userSelected } = user;

  const handleEdit = async (data: ObjectiveData) => {
    setObjectiveData({
      ...data,
      seasonId: userSelected?.season || 0,
      userId: userSelected?.id || 0,
    });
    onOpen();
  };

  const handleRegisterObjective = async (data: ObjectiveData) => {
    setLoading(true);
    const reponse = await updateGoal(
      data.goal,
      data.victory,
      data.date,
      data.userId,
      data.seasonId,
      data.id || 0,
      data.own_goal
    );
    if (!reponse) {
      toast({
        title: "Erro",
        description: "Ocorreu um erro ao atualizar.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }

    if (reponse) {
      await handleLoadPlayerHistory();
    }

    setLoading(false);
  };

  return (
    <Layout
      title={userSelected?.name}
      onBack={() => navigate(routes.team, { replace: true })}
    >
      <RegisterObjectiveModal
        key={objectiveData?.userId}
        isOpen={isOpen}
        onClose={onClose}
        onSubmit={handleRegisterObjective}
        seasonId={userSelected?.season || 0}
        userId={userSelected?.id || 0}
        name={userSelected?.name || ""}
        date={objectiveData?.date}
        goal={objectiveData?.goal}
        victory={objectiveData?.victory}
        id={objectiveData?.id}
        idEdit
        own_goal={objectiveData?.own_goal}
      />

      <Box px={4} pt={5}>
        <Text className="football-eyebrow">HISTÓRICO DO JOGADOR</Text>
        <Text fontSize="sm" color="#a7bcaf" mt={1}>Gols e vitórias, partida a partida.</Text>
      </Box>
      {!loading && history?.goals?.length === 0 && (
        <Box className="football-empty" m={4}>Nenhuma partida registrada nesta temporada.</Box>
      )}
      {loading && (
        <SimpleGrid columns={{ base: 1, md: 2, xl: 3 }} spacing={4} p={4}>
          {[...Array(6)].map((_, index) => (
            <Skeleton key={index} height="164px" borderRadius="16px" startColor="#1b2a22" endColor="#283e31" />
          ))}
        </SimpleGrid>
      )}

      {!loading && history?.goals && history?.goals.length > 0 && (
        <SimpleGrid columns={{ base: 1, md: 2, xl: 3 }} spacing={4} p={4}>
          {history?.goals?.map((player) => (
            <PlayerEdit
              key={player.id}
              goal={player.goal}
              victory={player.victory}
              date={player.date}
              edit={handleEdit}
              playerId={userSelected?.id || 0}
              seasonId={userSelected?.season || 0}
              id={player.id}
              isAdmin={!!(user.user?.admin ?? false)}
              own_goal={player.own_goal}
            />
          ))}
        </SimpleGrid>
      )}
    </Layout>
  );
};
